import { TranslationFile } from 'i18n'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { FormatEnumToList } from 'utils/commonhelpers'
import { PropertyType } from 'constants/enums/propertyTypes'
import { IApplicationInformation } from 'interfaces/i-application-information'
import { REGEX } from 'constants/values/commonRegExps'
import { JobTitle } from 'constants/enums/jobTitleTypes'
import { MaritalStatus } from 'constants/enums/maritalStatusTypes'

export const ContactFormUK = (data: IApplicationInformation) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Countries,
	])

	return {
		fieldSetName: '',
		formName: 'ContactForm',
		collapsable: false,
		description: t('Personal details'),
		show: true,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				controlName: 'cellPhone',
				type: 'text',
				label: t('forms:MobilePhoneNo'),
				displayFixedLabel: true,
				value: data?.contacts?.cellPhone,
				validations: [
					// {
					// 	code: 'MustMatchPattern',
					// 	value: REGEX.PHONE_NUMBER,
					// 	message: t('forms:ValidationMsgPhoneNumber'),
					// },
					{
						code: 'MustMatchPattern',
						value: REGEX.UK_PHONE_NUMBER,
						message: t('forms:ValidationMsgUKPhoneNumber'),
					},
				],
				required: true,
				visible: true,
				col: 6,
				inputPrefix: '+44 0',
			},
			{
				controlName: 'jobTitle',
				type: 'dropdown',
				label: t('forms:Occupation'),
				options: FormatEnumToList(
					JobTitle,
					PropertyType.JobTitle,
					TranslationFile.Dropdown,
				),
				value: data.employment?.jobTitle,
				required: false,
				visible: true,
				col: 6,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownOccupationType'),
			},
			{
				controlName: 'maritalStatus',
				type: 'dropdown',
				label: t('forms:RelationshipLable'),
				options: FormatEnumToList(
					MaritalStatus,
					PropertyType.MaritalStatus,
					TranslationFile.Dropdown,
				),
				value: data.personalInfo?.maritalStatus,
				required: false,
				visible: true,
				col: 12,
				wcagAriaLabel: t(
					'forms:WCAG-Label_DropDownRelationshipStatus',
				),
			},
		],
	}
}
